let obs;

const initUserData = () => {
    if (!obs) {
        obs = rxjs.from(IndexSvc.GetUserData());
    }

    return obs;
};

export const useUserStore = defineStore("user", {
    actions: {
        init(required) {
            initUserData().subscribe((data) => {
                if (data) {
                    this.id = data.UserId;
                    this.name = data.UserName;
                } else if (required) {
                    localStorage.OrigPage = location.href;
                    location.href = "/Login";
                }
            });

            return this;
        }
    },
    state: () => ({
        id: null,
        name: null
    })
});
